
const PageAddListing = () => {
    return (
        <div
            className={`nc-PageJoinPartner container pb-24 lg:pb-32`}
            data-nc-id="PageJoinPartner"
        >
            <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
                <div className="block flex-grow mb-24 lg:mb-0">
                    <div className="lg:sticky lg:top-24">
                        {/* LEFT */}

                    </div>
                </div>
                <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
                    {/* RIGHT */}
                </div>
            </main>
        </div>
    );
}

export default PageAddListing